/* eslint @typescript-eslint/explicit-function-return-type: off */

import React from 'react';
import PropTypes from 'prop-types';
import * as BS from 'react-bootstrap';
import Project from '../../models/Project';
import AdPerformanceReportDataSource from '../../models/AdPerformanceReportDataSource';
import AdPerformanceReportImportJob from '../../models/AdPerformanceReportImportJob';
import FormModal from './FormModal';

const scope =
  'frontend.components.AdPerformanceReportImportJob.FormModalButton';

const propTypes = {
  project: PropTypes.exact(Project.propTypes),
  dataSource: PropTypes.exact(AdPerformanceReportDataSource.propTypes),
  job: PropTypes.exact(AdPerformanceReportImportJob.propTypes),
};

class FormModalButton extends React.Component {
  static propTypes = propTypes;

  constructor(props) {
    super(props);

    this.toggleModal = this.toggleModal.bind(this);

    this.state = {
      modalShown: false,
    };
  }

  toggleModal(modalShown) {
    return (event) => {
      if (event) {
        event.preventDefault();
      }
      this.setState({ modalShown });
    };
  }

  render() {
    const { project, dataSource, job } = this.props;
    const { modalShown } = this.state;

    return (
      <>
        <BS.Button bsStyle='primary' onClick={this.toggleModal(true)}>
          {I18n.t(`${scope}.label`)}
        </BS.Button>
        <FormModal
          project={project}
          dataSource={new AdPerformanceReportDataSource(dataSource)}
          job={job}
          shown={modalShown}
          onHide={this.toggleModal(false)}
        />
      </>
    );
  }
}

export default FormModalButton;
